/** @format */

export default {
  methods: {
    validator: async function (types, key, fields) {
      if (Array.isArray(types) && types.length > 0) {
        let field;
        let name;
        let value;
        if (key.indexOf('.') !== -1) {
          field = key.split('.')[0];
          name = key.split('.')[1];
          value = fields?.[field]?.[name];
        } else value = fields.data?.[key] || fields[key];
        //const value = (field ? fields[field][name] : fields.data?.[key]) || fields[key];
        var ferror = '';
        for (var el of types) {
          let type = '';
          if (el[0] == '@') {
            type = '@';
            el = el.slice(1);
          }
          if (el == 'chk' && (value === '' || value === null || value === undefined)) {
            ferror = ' Не определено.';
          } else if (el == 'req' && (value === '' || value === null || value === undefined || (Array.isArray(value) && value.length == 0))) {
            ferror = 'Это поле обязательно.';
          } else if (el == 'noError' && value?._noError !== true) {
            ferror = 'Не верно заполнены данные';
          } else if (el == 'reqF') {
            let f = this.model.find((el) => el.name == key)?.validateFunc;
            if (f) {
              //console.log('validate func', f, fields);
              let func = eval(f);
              if (!func(fields)) ferror = `Это поле обязательно.`;
            }
          } else if (el == 'func') {
            let f = this.model.find((el) => el.name == key)?.validateFunc;
            if (f) {
              //console.log('validate func', f, fields);
              let func = eval(f);
              ferror = func(fields);
            }
          } else if (el == 'pass' && value && value.length < 6) {
            ferror = 'Пароль не менее 6 символов.';
          } else if (el == 'email' && value && value != '' && !this.validEmail(value)) {
            ferror = 'Укажите корректный адрес электронной почты.';
          } else if (el == 'tel' && value && value != '' && !this.validTel(value)) {
            ferror = 'Укажите номер телефона в правильном формате 7xxxxxxxxxx.';
          } else if (el == 'tel2' && value && value != '') {
            ferror = this.validTel2(value, key);
          } else if (el == 'login' && !(fields['id'] > 0)) {
            if (await this.validLogin(value, '/signup/login_exists')) {
              ferror = 'Такой пользователь уже существует';
            }
          } else if (el == 'inn') {
            ferror = await this.validInn(value);
          } else if (el == 'unique') {
            ferror = await this.isUnique(key, value, fields);
          } else if (el == 'api') {
            ferror = await this.validApi(key, value, fields);
          } else if (el == 'repass' && value != fields['password']) {
            ferror = 'Пароли не совпадают.';
          } else if (el == 'reemail' && value != fields['email']) {
            ferror = 'Адреса почты не совпадают';
          } else if (el == 'max') {
            let max = this.model.find((el) => el.name == key)?.max;
            if (max !== undefined && value > max) {
              ferror = `Значение не может быть больше ${max}`;
            }
          } else if (el == 'min') {
            let min = this.model.find((el) => el.name == key)?.min;
            if (min !== undefined && value < min) {
              ferror = `Значение должно быть больше ${min}`;
            }
          } else if (el.includes('len#')) {
            let type = el.split('#')[1];
            let l = parseInt(el.split('#')[2]);
            if (value)
              if (l !== undefined && ((value.length < l && type == 'min') || (value.length > l && type == 'max'))) {
                ferror = `Количество символов должно быть ${type == 'min' ? 'больше' : 'меньше'} ${l}`;
              }
          } else if (el.includes('max#')) {
            let max = parseFloat(el.split('#')[1]);
            if (value !== undefined && value !== null)
              if (max !== undefined && value > max) {
                ferror = `Значение не может быть больше ${max}`;
              }
          } else if (el.includes('min#')) {
            let min = parseFloat(el.split('#')[1]);
            if (value !== undefined && value !== null)
              if (min !== undefined && value < min) {
                ferror = `Значение должно быть больше ${min}`;
              }
          }
          if (ferror != '') {
            return type + ferror;
          }
        }
      }
      return '';
    },
    validEmail(email) {
      var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(email);
    },
    validTel(tel) {
      var re = /^7\d{10}$/;
      if (this.$root.profile.role == 1000) return re.test(tel) || /^996\d{9}$/.test(tel);

      return re.test(tel);
    },
    validTel2(tel, key) {
      let masks = [];
      let config = this.model.find((el) => el.name == key)?.config || {};
      if (config?.mask) {
        masks = config?.mask;
      } else masks = [this.model.find((el) => el.name == key)?.mask || '7**********'];
      let res = '';
      for (let i = 0; i < masks.length; i++) {
        const mask = masks[i];
        if (mask) {
          let m = new RegExp('^' + mask.replace(/\*/g, '\\d') + '$');
          if (!m.test(tel)) {
            res = config?.errorText || `Укажите номер формате ${mask}`;
          } else return '';
        }
      }
      return res;
    },
    async validApi(key, value, fields) {
      console.log('valid api check');
      const getParam = function (p, v) {
        let res = -1;
        let sub = eval(p || '-1');
        if (typeof sub === 'function') res = sub(v);
        else res = sub;
        return res;
      };
      let config = this.model.find((el) => el.name == key)?.validateApi;
      if (!config) return 'Ошибка проверки API1';
      let params = {};
      for (const key in config.params) {
        const el = config.params[key];
        params[key] = getParam(el, this.data);
      }
      let resp = await this.$axios.post(config.api, { name: config.name, params });
      let v = resp.data.data[0].value;
      let func = eval(config.func);
      return func(value, v);
      console.log(resp, v);
      return 'Ошибка проверки API';
    },

    async validLogin(login, api) {
      let response = await this.$axios.get(api, {
        params: { login: login },
      });
      return response.data.data;
    },
    async validInn(inn) {
      let result = false;
      let error = {};
      if (typeof inn === 'number') {
        inn = inn.toString();
      } else if (typeof inn !== 'string') {
        inn = '';
      }
      if (!inn.length) {
        return '';
        error.code = 1;
        error.message = 'ИНН пуст';
      } else if (/[^0-9]/.test(inn)) {
        error.code = 2;
        error.message = 'ИНН может состоять только из цифр';
      } else if ([10, 12].indexOf(inn.length) === -1) {
        error.code = 3;
        error.message = 'ИНН может состоять только из 10 или 12 цифр';
      } else {
        const checkDigit = (inn, coefficients) => {
          let n = 0;
          coefficients.forEach((k, i) => {
            n += k * parseInt(inn[i]);
          });
          return parseInt((n % 11) % 10);
        };
        switch (inn.length) {
          case 10:
            var n10 = checkDigit(inn, [2, 4, 10, 3, 5, 9, 4, 6, 8]);
            console.log({ inn, n10 });
            if (n10 === parseInt(inn[9])) {
              result = true;
            }
            break;
          case 12:
            var n11 = checkDigit(inn, [7, 2, 4, 10, 3, 5, 9, 4, 6, 8]);
            var n12 = checkDigit(inn, [3, 7, 2, 4, 10, 3, 5, 9, 4, 6, 8]);
            // console.log({ inn, n11, n12 });
            if (n11 === parseInt(inn[10]) && n12 === parseInt(inn[11])) {
              result = true;
            }
            break;
        }
        if (result) return '';
        if (!result) {
          error.code = 4;
          error.message = 'Неправильный номер ИНН';
        }
      }
      return error.message;
    },
    async isUnique(key, value, fields) {
      const model_ = this?.validate_model || this.model;
      const model = model_.find((m) => {
        return m.name == key;
      });
      if (!value) return '';
      const u = model?.unique || {};

      if ((model?.validator || []).includes('ifChanged')) {
        if (!this.changedFields?.[key]) return '';
      }
      try {
        // console.log(model, key);
        if (!u.api) {
          return 'Не удалось проверить на уникальность 1';
        }
        let params = { filters: Object.assign({ id: { condition: '<>', value: fields?.id || 0 }, [key]: value }, u?.filters || {}) };

        const resp = await this.$axios.get(u.api + '/count', { params });
        let status = resp.data.status == 'ok';
        if (!status) {
          return 'Не удалось проверить на уникальность 2';
        }
        if (resp.data.data !== 0) {
          return model?.unique?.errorText || model?.errorText || 'Значение должно быть уникальным';
        }
      } catch (error) {
        console.error(error);
        return 'Ошибка проверки на уникальность';
      }
      return '';
    },
  },
};
